import React, {useEffect, useState} from 'react';

import TeamCarousel from "./subcomponents/TeamCarousel";
import TeamAccordion from "./subcomponents/TeamAccordion";

export default function TeamView(props) {
    const [isMobileScreen, setIsMobileScreen] = useState(window.innerWidth < 768);

    const handleWindowSizeChange = () => {
        setIsMobileScreen(window.innerWidth < 768);
    };

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    let component;
    if (isMobileScreen) {
        component = TeamAccordion(props);
    } else {
        component = TeamCarousel(props);
    }

    return component;
}
    import { render } from 'react-dom'                                    
    if (window.reactComponents === undefined) {                           
      window.reactComponents = {}                                         
    }                                                                     
    window.reactComponents.TeamView = (function() {                   
    let _args = {}                                                        
                                                                          
    return {                                                              
      init: function (Args) {                                             
        _args = Args                                                      
      },                                                                  
      render: function () {                                               
        const  { id, ...props } = JSON.parse(_args)                       
        render(<TeamView {...props}/>, document.getElementById(id))   
      }                                                                   
    }                                                                     
  }())